export const colors = {
  "c-purple": "#8F79EA",
  "c-light-tourquise": "#B1F6E0",
  "c-tourquise": "rgba(78, 172, 185, 1)",
  "c-dark-blue": "rgba(30, 15, 154, 1)",
  approve: "#27C10E",
  maybe: "#ffffff",
  reject: "#F61724",
  waze: "#05C8F7",
};
